export { default } from "./AverageScoreProgressBar";
